import { SubscriptionModel } from '@/types/models/subscriptions';
import CheckboxEntity from '@/lib/formFactory/checkboxEntity';
import { CheckboxItem } from '@/lib/formFactory/checkbox.interface';
import InputEntity from '@/lib/formFactory/inputEntity';
import InputSuggestionEntity from '@/lib/formFactory/inputSuggestionEntity';
import MultiselectEntity from '@/lib/formFactory/multiselect/entity';

export default class EntityModel {
    model: SubscriptionModel;

    constructor() {
        const titleEntity = new InputEntity('title');
        titleEntity.setTitle('Название');
        titleEntity.setRequired(true);

        const periodicityEntity = new InputEntity('periodicity');
        periodicityEntity.setTitle('Периодичность');
        periodicityEntity.setRequired(true);

        const priceEntity = new InputEntity('price');
        priceEntity.setTitle('Стоимость');
        priceEntity.setRequired(true);

        const patientEntity = new InputEntity('patient');
        patientEntity.setTitle('Пациент');
        patientEntity.setRequired(true);

        const subscriptionTypeEntity = new InputSuggestionEntity('subscriptionType');
        subscriptionTypeEntity.setTitle('Тип подписки');
        subscriptionTypeEntity.setRequired(true);
        subscriptionTypeEntity.setDisabled(true);

        const checkboxItem: CheckboxItem = {
            id: 1,
            name: 'Активен',
            checked: true,
        };

        const isActiveEntity = new CheckboxEntity('isActive');
        isActiveEntity.setName('Активен');
        isActiveEntity.setList([checkboxItem]);

        const subscriptionPackEntity = new MultiselectEntity('subscriptionPack');
        subscriptionPackEntity.setDisabled(true);

        const specializationsEntity = new MultiselectEntity('specializations')
            .setTitle('Специализации');
        specializationsEntity.setDisabled(true);

        const medicalServiceTypesEntity = new MultiselectEntity('medicalServiceType')
            .setTitle('Услуги');
        medicalServiceTypesEntity.setDisabled(true);

        this.model = {
            title: titleEntity.entity[titleEntity.entityName],
            periodicity: periodicityEntity.entity[periodicityEntity.entityName],
            price: priceEntity.entity[priceEntity.entityName],
            patient: patientEntity.entity[patientEntity.entityName],
            subscriptionType: subscriptionTypeEntity.entity[subscriptionTypeEntity.entityName],
            isActive: isActiveEntity.entity,
            subscriptionPack: subscriptionPackEntity.entity,
            specializations: specializationsEntity.entity,
            medicalServiceTypes: medicalServiceTypesEntity.entity,
            startAt: '',
            endAt: '',
        };
    }
}
